<template>
  <div
    v-if="banner.data"
    class="material-banner"
  >
    <material-banner-variant1
      v-if="banner.data.designVariant === 1"
      :banner="banner.data.payload"
    />
  </div>
</template>

<script>
import MaterialBannerVariant1 from './MaterialBannerVariant1.vue';

export default {
  name: 'MaterialBanner',
  components: { MaterialBannerVariant1 },
  props: {
    banner: { type: Object, required: true },
  },
};
</script>
